import map from "lodash/map"
import uniq from "lodash/uniq"
import filter from "lodash/filter"
import { MIL_TO_MOA } from "./constants"

export default {
  currentScope(state) { return state.currentScope },
  currentBrand(state) { return state.currentBrand },
  currentScopeBrand(state) { return state.currentScopeBrand },
  permittedCurrentScope(state) {
    return state.currentScope === "other" ? null : state.currentScope
  },
  // Turret
  isImperial(state) { return state.isImperial },
  turretHeight(state) { return state.turretHeight },
  turretDiameter(state) { return state.turretDiameter },
  // Scope
  sightHeight(state) { return state.sightHeight },
  clickUnit(state) { return state.clickUnit },
  clickValue(state) { return state.clickValue },
  clicksPerRotation(state) { return state.clicksPerRotation },
  direction(state) { return state.direction },
  numberOfRevolutions(state) { return state.numberOfRevolutions },
  maxNumberOfRevolutions(state) { return state.maxNumberOfRevolutions },
  maxMoa(state) {
    let maxMoa = state.clicksPerRotation * state.numberOfRevolutions * state.clickValue

    if (state.clickUnit === "mil") {
      maxMoa *= MIL_TO_MOA
    }

    return maxMoa
  },
  // Firearm
  initialVelocity(state) { return state.initialVelocity },
  zeroRange(state) { return state.zeroRange },
  // Environment
  altitude(state) { return state.altitude },
  pressure(state) { return state.pressure },
  temperature(state) { return state.temperature },
  humidity(state) { return state.humidity },
  // Ammunition
  ammuntionBrands(state) {
    let ammunitions = state.ammunitions;

    let results = ammunitions.sort((a, b) => {
      return a.brand.localeCompare(b.brand, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });

    return uniq(map(results, (ammunition) => ammunition.brand))
  },
  ammunitionCalibers(state) {
    let results = filter(state.ammunitions, {brand: state.currentAmmunitionBrand})
    results = map(results, (ammunitionCaliber) => ammunitionCaliber.caliber)

    results = results.sort((a, b) => {
      return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    })
    return uniq(results)
  },
  ammunitions(state) {
    let results = filter(state.ammunitions, {brand: state.currentAmmunitionBrand, caliber: state.currentAmmunitionCaliber})
    results = results.sort((a, b) => a.name.localeCompare(b.name) || b.weight - a.weight);
    
    return results
  },
  currentAmmunitionBrand(state) { return state.currentAmmunitionBrand },
  currentAmmunitionCaliber(state) { return state.currentAmmunitionCaliber },
  currentAmmunition(state) { return state.currentAmmunition },
  dragFunction(state) { return state.dragFunction },
  dragCoefficient(state) { return state.dragCoefficient },
  ammunitionWeight(state) { return state.ammunitionWeight },
  // Products
  currentScopeProductVariant(state) { return state.currentScopeProductVariant },
  // Calculation
  isCalculationLoading(state) {
    return state.isCalculationLoading
  },
  calculationResults(state) {
    return state.calculationResults
  }
}